import React, { useEffect, useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'

function Animation({ autoplay = false, loop = false, name, className, style }) {
  const [animation, setAnimation] = useState(null)
  const animationRef = useRef(null)
  const [inViewRef, inView] = useInView({ threshold: 0.8, triggerOnce: true })

  useEffect(() => {
    if (!inView) return

    let animationParams = {
      container: animationRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData: null,
    }

    Promise.all([
      import(
        /* webpackChunkName: "BodyMovin" */ 'bodymovin/build/player/bodymovin_light'
      ),
      import(/* webpackChunkName: "[request]" */ `./animations/${name}`),
    ]).then(function([bodymovin, animationData]) {
      animationParams.animationData = animationData.default

      setAnimation(bodymovin.loadAnimation(animationParams))
    })
  }, [animationRef, inView])

  useEffect(() => {
    if (animation) {
      setTimeout(function() {
        animation.play()
      }, 750)
    }
  }, [animation])

  const setRefs = useCallback(
    node => {
      // Ref's from useRef needs to have the node assigned to `current`
      animationRef.current = node
      // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
      inViewRef(node)
    },
    [inViewRef]
  )

  return <div className={className} ref={setRefs} style={style} />
}

Animation.propTypes = {
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Animation
